<!-- Loading inicial -->
<div class="text-center py-5" *ngIf="loadingProfessionals">
  <div class="spinner-border text-primary"></div>
  <p class="mt-3 text-muted">Carregando profissionais...</p>
</div>

<!-- Empty state — nenhum profissional cadastrado -->
<div class="empty-state" *ngIf="!loadingProfessionals && professionals.length === 0">
  <div class="empty-emoji">👨‍⚕️</div>
  <h3>Cadastre seu primeiro profissional</h3>
  <p class="text-muted">
    Cada profissional tem agenda própria, lista de pacientes e financeiro independente.
  </p>
  <button class="btn btn-primary btn-lg px-5" (click)="requestModal()">
    <i class="bi bi-plus-lg me-2"></i>Cadastrar Profissional
  </button>
  <p class="mt-3 text-muted small">🎉 30 dias grátis · R$ 39,90/mês após o trial</p>
</div>

<!-- Dashboard com profissional selecionado -->
<div *ngIf="selectedProfessional && !loadingProfessionals">

  <!-- Cabeçalho do profissional -->
  <div class="prof-header-card mb-4">
    <div class="prof-header-avatar">{{ initials(selectedProfessional.name) }}</div>
    <div class="prof-header-info">
      <div class="prof-header-name">{{ selectedProfessional.name }}</div>
      <div class="prof-header-meta">
        <span *ngIf="selectedProfessional.specialty">
          <i class="bi bi-briefcase-medical me-1"></i>{{ selectedProfessional.specialty }}
        </span>
        <span *ngIf="selectedProfessional.professionalId" class="ms-3">
          <i class="bi bi-person-badge me-1"></i>{{ selectedProfessional.professionalId }}
        </span>
        <span *ngIf="selectedProfessional.email" class="ms-3">
          <i class="bi bi-envelope me-1"></i>{{ selectedProfessional.email }}
        </span>
        <span *ngIf="selectedProfessional.phone" class="ms-3">
          <i class="bi bi-telephone me-1"></i>{{ selectedProfessional.phone }}
        </span>
      </div>
    </div>
    <div class="prof-header-badges">
      <span [class]="subClass(selectedProfessional?.subscription?.status)">
        {{ subLabel(selectedProfessional?.subscription?.status) }}
      </span>
      <span class="badge bg-warning text-dark ms-1"
            *ngIf="selectedProfessional?.subscription?.status === 1">
        {{ daysRemaining(selectedProfessional?.subscription?.trialEndDate) }}d restantes
      </span>
    </div>
  </div>

  <!-- Alerta Trial -->
  <div class="alert-trial" *ngIf="selectedProfessional?.subscription?.status === 1">
    <i class="bi bi-gift-fill"></i>
    <span>
      <strong>Trial ativo!</strong> Você tem
      <strong>{{ daysRemaining(selectedProfessional?.subscription?.trialEndDate) }} dias</strong>
      grátis para <em>{{ selectedProfessional.name }}</em>.
    </span>
    <a (click)="navigate('/professionals')" href="javascript:void(0)">
      Configurar pagamento →
    </a>
  </div>

  <!-- Alerta Pagamento Atrasado -->
  <div class="alert-pastdue" *ngIf="selectedProfessional?.subscription?.status === 3">
    <i class="bi bi-exclamation-triangle-fill"></i>
    <span>
      <strong>Pagamento atrasado</strong> para <em>{{ selectedProfessional.name }}</em>.
      Regularize para não perder o acesso.
    </span>
    <a (click)="navigate('/professionals')" href="javascript:void(0)">Regularizar →</a>
  </div>

  <!-- Cards de stats -->
  <div class="stats-grid">

    <div class="stat-card purple">
      <div class="stat-left">
        <div class="stat-val">{{ stats.todayTotal }}</div>
        <div class="stat-label">Consultas Hoje</div>
        <div class="stat-sub">{{ stats.todayConfirmed }} confirmadas</div>
      </div>
      <i class="bi bi-calendar-check stat-icon"></i>
    </div>

    <div class="stat-card orange">
      <div class="stat-left">
        <div class="stat-val">{{ stats.todayPending }}</div>
        <div class="stat-label">Pendentes Hoje</div>
        <div class="stat-sub">Aguardando confirmação</div>
      </div>
      <i class="bi bi-hourglass-split stat-icon"></i>
    </div>

    <div class="stat-card blue">
      <div class="stat-left">
        <div class="stat-val">{{ stats.weekTotal }}</div>
        <div class="stat-label">Próximos 7 Dias</div>
        <div class="stat-sub">Agendamentos</div>
      </div>
      <i class="bi bi-calendar-week stat-icon"></i>
    </div>

    <div class="stat-card teal">
      <div class="stat-left">
        <div class="stat-val">{{ stats.totalPatients }}</div>
        <div class="stat-label">Pacientes Ativos</div>
        <div class="stat-sub">{{ fmtCurrency(stats.monthRevenue) }} este mês</div>
      </div>
      <i class="bi bi-people stat-icon"></i>
    </div>

  </div>

  <!-- Ações rápidas -->
  <div class="quick-actions">
    <button class="quick-btn" (click)="navigate('/agenda')">
      <i class="bi bi-plus-circle-fill"></i>
      <span>Novo Agendamento</span>
    </button>
    <button class="quick-btn" (click)="navigate('/patients')">
      <i class="bi bi-person-plus-fill"></i>
      <span>Novo Paciente</span>
    </button>
    <button class="quick-btn" (click)="navigate('/agenda')">
      <i class="bi bi-calendar3"></i>
      <span>Ver Agenda</span>
    </button>
    <button class="quick-btn" (click)="navigate('/payments')">
      <i class="bi bi-cash-coin"></i>
      <span>Financeiro</span>
    </button>
  </div>

  <!-- Agendamentos: Hoje + Próximos -->
  <div class="appts-grid">

    <div class="appt-panel">
      <div class="appt-panel-header">
        <h6><i class="bi bi-sun me-2"></i>Hoje</h6>
        <button class="btn btn-sm btn-outline-primary" (click)="navigate('/agenda')">
          Ver agenda
        </button>
      </div>
      <div class="appt-panel-body">
        <div class="appt-empty" *ngIf="!loadingStats && todayAppointments.length === 0">
          <i class="bi bi-calendar-x"></i>
          <span>Nenhum agendamento hoje</span>
        </div>
        <div class="spinner-border spinner-border-sm text-primary m-3"
             *ngIf="loadingStats"></div>
        <div class="appt-row" *ngFor="let a of todayAppointments">
          <div class="appt-time">{{ fmtTime(a.startTime) }}</div>
          <div class="appt-info">
            <strong>{{ a.patientName || 'Paciente' }}</strong>
            <small>{{ a.serviceType || 'Consulta' }}</small>
          </div>
          <span [class]="apptStatusClass(a.status)">{{ apptStatusLabel(a.status) }}</span>
        </div>
      </div>
    </div>

    <div class="appt-panel">
      <div class="appt-panel-header">
        <h6><i class="bi bi-calendar-week me-2"></i>Próximos</h6>
      </div>
      <div class="appt-panel-body">
        <div class="appt-empty" *ngIf="!loadingStats && upcomingAppointments.length === 0">
          <i class="bi bi-calendar-check"></i>
          <span>Agenda livre nos próximos dias</span>
        </div>
        <div class="spinner-border spinner-border-sm text-primary m-3"
             *ngIf="loadingStats"></div>
        <div class="appt-row" *ngFor="let a of upcomingAppointments">
          <div class="appt-date">
            <div class="appt-date-day">{{ fmtDate(a.startTime) }}</div>
            <small>{{ fmtTime(a.startTime) }}</small>
          </div>
          <div class="appt-info">
            <strong>{{ a.patientName || 'Paciente' }}</strong>
            <small>{{ a.serviceType || 'Consulta' }}</small>
          </div>
          <span [class]="apptStatusClass(a.status)">{{ apptStatusLabel(a.status) }}</span>
        </div>
      </div>
    </div>

  </div>
</div>
